<template>
  <li class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2 wf-items-center wf-relative">
    <span class="wf-font-light wf-lowercase wf-text-gray-500 wf-w-1/2 wf-text-xs wf-tracking-wide">Custom Classes</span>
    <input
      v-model="newCustomClasses"
      @keydown.enter="addClasses"
      type="text"
      class="wf-w-1/2 focus:wf-bg-gray-300 wf-text-xs wf-bg-gray-300 wf-text-gray-700 wf-border wf-rounded focus:wf-outline-none wf-px-2 wf-py-1"
    />
    <div class="wf-flex wf-flex-wrap wf-mt-1">
      <button
        @click.prevent="removeClass(index)"
        class="focus:wf-outline-none wf-mt-1 wf-mr-1 hover:wf-bg-blue-300 wf-text-xxs wf-font-semibold wf-inline-block wf-px-2 wf-py-1 wf-bg-blue-400 wf-rounded-md wf-text-white hover:wf-shadow"
        v-for="(customClass, index) in customClasses"
        :key="customClass"
        v-text="customClass"
      ></button>
    </div>
  </li>
</template>

<script>
  import ArrayManipulation from  '../mixins/ArrayManipulation'
  export default {
    props: {
      parentModule: {
        type: String,
        required: false
      },
      element: {
        type: Object,
        required: true,
      }
    },
    mixins: [ArrayManipulation],
    data() {
      return {
        newCustomClasses: ''
      }
    },
    computed: {
      elementSidebar() {
        return this.$store.getters['settingsModule/elementSidebar']
      },
      parentElement() {
        if(! this.elementSidebar) {
          return this.$parent.$parent.parent  
        }
        return this.$parent
      },
      customClasses() {
          return this.parentElement.customClasses
      }
    },
    methods: {
      addClasses() {
        let classes = this.newCustomClasses.split(' ').map(string => string.trim())
        classes = classes.filter(newClass => ! this.customClasses.includes(newClass))
        this.addToArray(this.parentElement.module, classes, 'customClasses', null, this.element, true, this.parentModule)
        this.newCustomClasses = ''
      },
      removeClass(classIndex) {
        let customClass = this.customClasses[classIndex]
        this.removeFromArray(this.parentElement.module, [customClass], 'customClasses', null, this.element, true, this.parentModule)
      }
    }
  }
</script>